import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MaintenanceService } from '../../services/maintenance.service';

@Component({
    selector: 'app-maintenance-overlay',
    templateUrl: './maintenance-overlay.component.html',
    styleUrls: ['./maintenance-overlay.component.scss']
})
export class MaintenanceOverlayComponent implements OnInit, OnDestroy {
    isVisible = false;
    private subscription: Subscription;

    constructor(private maintenanceService: MaintenanceService) { }

    ngOnInit() {
        this.subscription = this.maintenanceService.maintenance$.subscribe(
            (show) => {
                this.isVisible = show;
                this.updateBodyClass(show);
            }
        );
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.updateBodyClass(false);
    }

    private updateBodyClass(show: boolean) {
        if (show) {
            document.body.classList.add('has-maintenance-banner');
        } else {
            document.body.classList.remove('has-maintenance-banner');
        }
    }

    retry() {
        this.maintenanceService.hideMaintenance();
        window.location.reload();
    }

    close() {
        this.maintenanceService.hideMaintenance();
    }
} 